export default __webpack_public_path__ + "static/media/pp.984a960a.png";